/**
 * Audit log cursor DTO for records
 */
export class AuditLogCursorDto {
	id!: number;
	lastId!: number;
}
